import { Box, Radio, Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import { ReportHeading } from '../../Reports/common/ReportHeading'
import { AcountingHeading } from '../common/AcountingHeading'
import styled from '@emotion/styled'
import UserWiseBalance from './UserWiseBalance'
import BranchWiseBalance from './BranchWiseBalance'
import useToken from '../../../helpers/useTokens'
const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    height: 4,
    backgroundColor: theme.palette.primary.main,
  },
}))
const tabSx = {
  minHeight: '30px',
  height: '35px',
  flex: 1,
  maxWidth: '150px',
  padding: '5px 12px',
  position: 'relative',
  '&.Mui-selected': {
    border: 'none',
    minHeight: '30px',
    height: '30px',
  },
  '&.Mui-selected::after': {
    content: '""',
    position: 'absolute',
    left: '6px',
    right: '6px',

    bottom: '0px',
    height: '4px',
    backgroundColor: '#0086ff',
  },
}
const BankingReport = () => {
  const [selectedTab, setSelectedTab] = useState(0)
  const reportName = 'Banking'
 let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    isFromUrl = true
  }
  const bankingTabs = [
    { id: 0, name: 'Branchwise Balance' },
    { id: 1, name: 'Userwise Balance' },
  ]
    const bankingTabsShort = [
    { id: 0, name: 'Branchwise' },
    { id: 1, name: 'Userwise' },
  ]
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }
  return (
    <>
      <Box sx={{ padding: '0', gap: '15px' }} className="reports" style={{}}>
         {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
          {isFromUrl ? <></> : <AcountingHeading reportName={reportName} />}
        <Box>
          <StyledTabs
            aria-label="basic tabs example"
            value={selectedTab}
            onChange={handleTabChange}
            sx={{
              backgroundColor: '#e5f3fe',
              height: '30px',
              minHeight: '37px',
              border: 'none',
              padding: '3px 25px',

              ...(isFromUrl && {
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
              }),
            }}
          >
            {(isFromUrl?bankingTabsShort:bankingTabs).map((tab) => (
              <Tab
                key={tab.id}
                label={tab.name}
                sx={isFromUrl ? tabSx : 
                  {
                  minHeight: '30px', height: '30px', '&.Mui-selected': {
                    border: 'none',
                    minHeight: '30px',
                    height: '30px',
                  },
                }}
              />

            ))}
          </StyledTabs>
        </Box>
        <>
          {selectedTab === 0 && <BranchWiseBalance isFromUrl={isFromUrl} />}
          {selectedTab === 1 && <UserWiseBalance isFromUrl={isFromUrl} />}
        </>
      </Box>
    </>
  )
}

export default BankingReport
